import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import PendingDocsPage from "../../../auxiliary/pending/PendingDocsPage";
import "../../change/cw.scss";

const CWListPendingDocument = () => {
	const [t] = useTranslation("global");
	const { queryCOPurchaseDealerByState } = useDealer();
	return (
		<PendingDocsPage
			title={t("changeOwnerShip.pending.list.title")}
			prefix="cw"
			query={queryCOPurchaseDealerByState}
			stateFilter={{ purchasestate: [1, 15] }}
			commissionTitle="پورسانت"
			uploadPath={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.upload}
			toRow={(item) => ({
				trackcode: item.stR_COFollowupCode,
				msisdn: item.inT_MSISDN,
				type: item.stR_BundleName,
				price: complexDigitToman(item.inT_PurchaseAmount),
				commission: complexDigitToman(item.inT_PackageSalesCommission),
				purchaseDate: convertToJalaliWithTime(item.dtE_OperationDate),
			})}
		/>
	);
};

export default CWListPendingDocument;
